import React, { FunctionComponent } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { owlImageProps } from 'src/resources/images';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

export const PageInFlightOrder: FunctionComponent = () => (
  <CommonError
    title={i18n.page.error.inflight.title}
    subtitles={[i18n.page.error.inflight.mainSubtitle, i18n.page.error.inflight.subtitle]}
    image={owlImageProps}
    dataLayerErrorMessage={DataLayerEcomErrors.INFLIGHT_ORDER_ERROR}
  />
);
